import React from 'react';
import ReloadIcon from 'material-ui/svg-icons/action/cached';

export default function Reload({ reloadAction }) {
    return (
        <ReloadIcon 
            style={{ 
                transform: 'translate(10px, 10px)',
                cursor: 'pointer'
            }}
            onClick={reloadAction}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Reload.jsx